module.exports = __webpack_public_path__ + "static/media/wave_crashing.24792a9b.jpg";